
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class BrandAmbassadorPaymentsGrid extends Serenity.EntityGrid<BrandAmbassadorPaymentsRow, any> {
        protected getColumnsKey() { return BrandAmbassadorPaymentsColumns.columnsKey; }
        protected getDialogType() { return BrandAmbassadorPaymentsDialog; }
        protected getIdProperty() { return BrandAmbassadorPaymentsRow.idProperty; }
        protected getInsertPermission() { return BrandAmbassadorPaymentsRow.insertPermission; }
        protected getLocalTextPrefix() { return BrandAmbassadorPaymentsRow.localTextPrefix; }
        protected getService() { return BrandAmbassadorPaymentsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}